import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class PalletTransactions_ds_get_orders_by_project_ddService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { project_id?: number, full_text_search?: string, order_id?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { LookupCode?: string } }[] }[] }> 
  {
    let url = `${environment.backendUrl}api/PalletTransactions/datasources/ds_get_orders_by_project_dd/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { project_id?: number, full_text_search?: string, order_id?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { LookupCode?: string } }[] }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/PalletTransactions/datasources/ds_get_orders_by_project_dd/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { project_id?: number, full_text_search?: string, order_id?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { LookupCode?: string } }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/PalletTransactions/datasources/ds_get_orders_by_project_dd/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      project_id?: number, full_text_search?: string, order_id?: number    }) {
      return false;
    }
}
